// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"801a1c9f","531":"6beac3f0","705":"5050bae1","787":"871b41c3","804":"516cbebf","888":"e7e87b0b","931":"f78f9056"}[chunkId] + ".chunk.js";
};